// Export action type constants for ExportDuck

export const EXPORT_ACTIONS = {
  EXPORT_START: 'exportStart',
  EXPORT_REQUEST: 'exportRequest',
  EXPORT_PROGRESS: 'exportProgress',
  EXPORT_SUCCESS: 'exportSuccess',
  EXPORT_SUCCESS_CLEANUP: 'exportSuccessCleanup',
  /**
   * @deprecated use only to indicate an error occurred during export process, no payload
   */
  EXPORT_ERROR: 'exportError',
  EXPORT_CANCEL: 'exportCancel',
  EXPORT_UPDATE_DIALOG: 'exportUpdateDialog'
} as const

export type ExportDuckActionType = (typeof EXPORT_ACTIONS)[keyof typeof EXPORT_ACTIONS]
